import type React from 'react';
import { Alert, Text } from 'braid-design-system';

interface Props {
  message: string;
}

const Error: React.FunctionComponent<Props> = ({ message }) => (
  <Alert tone="critical">
    <Text>{message}</Text>
  </Alert>
);

export default Error;
